import { useCallback, useEffect, useRef } from "react";

/**
 * Fires `fire` once, at the mascot's apex (`onPeak`) or, if that never comes,
 * `fallbackMs` after mount. The still and reduced motion never report a peak,
 * and a haptic must not depend on a player that may not have loaded.
 */
export function usePeak(fire: () => void, fallbackMs = 700): () => void {
	const done = useRef(false);
	const latest = useRef(fire);
	latest.current = fire;
	const peak = useCallback(() => {
		if (done.current) return;
		done.current = true;
		latest.current();
	}, []);
	useEffect(() => {
		const id = setTimeout(peak, fallbackMs);
		return () => clearTimeout(id);
	}, [peak, fallbackMs]);
	return peak;
}
